import { EnvironmentProviders, computed, inject, makeEnvironmentProviders } from '@angular/core';
import { NAV_ITEMS, NavItem, provideNavigation, providePrimaryAction } from '../../core/navigation';
import { AuthStore } from '../../core/auth/auth.store';
import { SitesApi } from '../sites-data/sites.api';

/** Voci del contesto `home`, fuori da un cantiere (FR-022). */
export function provideDashboardNavigation(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideNavigation(
      {
        id: 'home.dashboard',
        label: 'Dashboard',
        icon: 'home',
        route: '/',
        context: 'home',
        section: 'main',
        order: 10,
        exact: true,
        mobile: true,
      },
      {
        id: 'home.notifications',
        label: 'Notifiche',
        icon: 'bell',
        route: '/notifications',
        context: 'home',
        section: 'main',
        order: 20,
        mobile: true,
      },
      {
        id: 'home.profile',
        label: 'Profilo',
        icon: 'user',
        route: '/profile',
        context: 'home',
        section: 'main',
        order: 30,
        mobile: true,
      },
      {
        id: 'home.subscription',
        label: 'Abbonamento',
        icon: 'subscription',
        route: '/subscription',
        context: 'home',
        section: 'main',
        order: 40,
        mobile: true,
      },
    ),
    // "Inviti" con il numero degli inviti in sospeso (FR-011, tavola 1A).
    {
      provide: NAV_ITEMS,
      multi: true,
      useFactory: (): NavItem => {
        const api = inject(SitesApi);
        return {
          id: 'home.invitations',
          label: 'Inviti',
          icon: 'mail',
          route: '/invites',
          context: 'home',
          section: 'main',
          order: 15,
          badge: computed(() => {
            const count = api.all.hasValue() ? (api.all.value().invitations?.length ?? 0) : 0;
            return count > 0 ? count : null;
          }),
        };
      },
    },
    // Console del catalogo, solo per gli operatori della piattaforma (spec 004 research R-13).
    {
      provide: NAV_ITEMS,
      multi: true,
      useFactory: (): NavItem => {
        const auth = inject(AuthStore);
        return {
          id: 'home.admin',
          label: 'Console',
          icon: 'grid',
          route: '/admin/catalog',
          context: 'home',
          section: 'secondary',
          order: 90,
          visible: computed(() => auth.user()?.isPlatformOperator === true),
        };
      },
    },
    providePrimaryAction({ context: 'home', label: 'Nuovo cantiere', route: '/sites/new' }),
  ]);
}
